export default __webpack_public_path__ + "static/media/facebook-light.1c95d1c7.svg";